module.exports = __webpack_public_path__ + "static/img/img5.ffc7c09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img5.jpg
// module id = 3FXG
// module chunks = 1